import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { GetUserVideo, UploadVideo } from '../../Api';

const VideoModel = ({ isOpen, closeModal, userId }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [assignUserVideo, setAssignUserVideo] = useState([]);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [categories, setCategories] = useState('');

  // Fetch user videos when the modal opens
  useEffect(() => {
    if (isOpen && userId) {
      GetUserVideo(userId)
        .then((result) => {
          console.log(result.data);
          setAssignUserVideo(result.data);
        })
        .catch((error) => {
          console.error('Error fetching user videos:', error);
        });
    }
  }, [isOpen, userId]);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleAssignClick = async () => {
    if (!selectedFile) {
      alert('Please select a file first!');
      return;
    }
    if (!title) {
      alert('Please enter a title!');
      return;
    }

    try {
      await UploadVideo(userId, title, description, categories, selectedFile);
      const updatedVideos = await GetUserVideo(userId);
      setAssignUserVideo(updatedVideos.data);
      // Reset all fields after successful upload
      setSelectedFile(null);
      setTitle('');
      setDescription('');
      setCategories('');
    } catch (error) {
      console.error('Error uploading video:', error);
    }
  };

  const handleCloseModal = () => {
    setAssignUserVideo([]);
    setSelectedFile(null);
    setTitle('');
    setDescription('');
    setCategories('');
    closeModal();
  };

  return (
    isOpen && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="fixed inset-0 bg-black/70 flex justify-center items-center z-50"
      >
        <motion.div
          initial={{ y: '-100vh' }}
          animate={{ y: 0 }}
          exit={{ y: '-100vh' }}
          transition={{ duration: 0.3 }}
          className="bg-gradient-to-br from-gray-800 to-black p-6 rounded-lg w-full h-full max-w-none max-h-none overflow-auto"
        >
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-6 text-white">Assign Video</h2>

            <div className="mb-6">
              <label className="block text-gray-300 text-sm font-medium">Title</label>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="mt-2 p-3 border border-gray-600 bg-gray-700 text-gray-200 rounded w-full focus:outline-none focus:ring focus:ring-blue-500"
              />
            </div>

            <div className="mb-6">
              <label className="block text-gray-300 text-sm font-medium">Description</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="mt-2 p-3 border border-gray-600 bg-gray-700 text-gray-200 rounded w-full focus:outline-none focus:ring focus:ring-blue-500 h-32 resize-none"
              />
            </div>

            <div className="mb-6">
              <label className="block text-gray-300 text-sm font-medium">Categories</label>
              <input
                type="text"
                value={categories}
                onChange={(e) => setCategories(e.target.value)}
                placeholder="Enter categories separated by commas"
                className="mt-2 p-3 border border-gray-600 bg-gray-700 text-gray-200 rounded w-full focus:outline-none focus:ring focus:ring-blue-500"
              />
            </div>

            <div className="mb-6">
              <label className="block text-gray-300 text-sm font-medium">Select File</label>
              <input
                type="file"
                accept=".mp4, .mkv"
                onChange={handleFileChange}
                className="mt-2 p-3 border border-gray-600 bg-gray-700 text-gray-200 rounded w-full focus:outline-none focus:ring focus:ring-blue-500"
              />
            </div>

            <div className="flex justify-between mt-8">
              <button
                onClick={handleCloseModal}
                className="py-3 px-6 bg-gray-600 hover:bg-gray-700 text-white rounded-lg transition-all duration-200"
              >
                Cancel
              </button>
              <button
                onClick={handleAssignClick}
                className="py-3 px-6 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-all duration-200"
              >
                Assign
              </button>
            </div>

            <div className="mt-8">
              <h3 className="text-xl font-semibold mb-4 text-white">Assigned Videos</h3>
              <div className="grid gap-4">
                {assignUserVideo.length > 0 ? (
                  assignUserVideo.map((video) => (
                    <motion.div
                      key={video.id}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -20 }}
                      transition={{ duration: 0.3 }}
                      className="p-4 border border-gray-700 rounded-lg flex justify-between items-center bg-gray-800"
                    >
                      <div>
                        {video.title && (
                          <p className="font-semibold text-gray-300">{video.title}</p>
                        )}
                        <p className="text-sm text-gray-400">
                          Uploaded on: {new Date(video.uploadDate).toLocaleDateString()}
                        </p>
                        <a
                          href={video.weburl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 text-sm underline hover:text-blue-600"
                        >
                          View Video
                        </a>
                      </div>
                    </motion.div>
                  ))
                ) : (
                  <p className="text-gray-300">No videos assigned yet.</p>
                )}
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>
    )
  );
};

export default VideoModel;